import React, { createContext, useEffect } from "react"

import { useAppSelector, useAppDispatch } from "redux/hooks"
import { SubscriptionEligibilityType } from "types"
import { selectId } from "redux/features/auth/authSlice"
import {
  selectSubscriptionEligibilityById,
  selectFetchStatus,
} from "redux/features/subscription_eligibility/subscriptionEligibilitySlice"
import { fetchSubscriptionEligibility } from "redux/features/subscription_eligibility/subscriptionEligibilityThunk"

const DEFAULT_SUBSCRIPTION = {
  id: 0,
  active: false,
  eligible: false,
  added: false,
  need_subscription: false,
  allow_subscribe: false,
}

interface SubscriptionContext {
  subscription: SubscriptionEligibilityType
  needSubscription: boolean
  allowSubscribe: boolean
}

export const SubscriptionContext = createContext<SubscriptionContext>({
  subscription: DEFAULT_SUBSCRIPTION,
  needSubscription: false,
  allowSubscribe: false,
})

export const SubscriptionContextProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const dispatch = useAppDispatch()

  const clientId = useAppSelector((state) => selectId(state)) || ""
  const fetchStatus = useAppSelector((state) => selectFetchStatus(state))

  useEffect(() => {
    const handleFetchSubscriptionEligibility = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchSubscriptionEligibility())
      }
    }

    handleFetchSubscriptionEligibility()
  }, [])

  const subscription =
    useAppSelector(
      (state) =>
        selectSubscriptionEligibilityById(
          state,
          clientId,
        ) as SubscriptionEligibilityType,
    ) || DEFAULT_SUBSCRIPTION
  const { need_subscription, allow_subscribe } = subscription

  return (
    <SubscriptionContext.Provider
      value={{
        subscription: subscription,
        needSubscription: need_subscription,
        allowSubscribe: allow_subscribe,
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  )
}
